/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'

import { Paper, Typography, Tabs, Tab, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Popper, Popover, Select, MenuItem, FormControl, InputLabel, Button, IconButton, Collapse, Divider, Accordion, AccordionSummary, AccordionDetails, Dialog, CircularProgress } from '@material-ui/core'
import { ArrowLeft, Clear, ExpandMore, KeyboardArrowLeft, ViewList, Visibility, VisibilityOff } from '@material-ui/icons'

import Action from "../../../fluid/Actions/ActionFactory";
import PDFtronViewer from './Components/PDFtronViewer'
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import Actions from '../../../fluid/Actions/ActionFactory';


const blue_theme = createTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});
const AntTabs = withStyles({
    root: {
      borderBottom: '1px solid #e8e8e8',
    },
    indicator: {
      backgroundColor: '#1890ff',
    },
})(Tabs);

const AntTab = withStyles((theme) => ({
    root: {
      textTransform: 'none',
      minWidth: 72,
      fontWeight: theme.typography.fontWeightRegular,
      marginRight: theme.spacing(4),
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      '&:hover': {
        color: '#40a9ff',
        opacity: 1,
      },
      '&$selected': {
        color: '#1890ff',
        fontWeight: theme.typography.fontWeightMedium,
      },
      '&:focus': {
        color: '#40a9ff',
      },
    },
    selected: {},
}))((props) => <Tab disableRipple {...props} />);

const styles = theme => ({

})

class Review extends Component {
    state = {
        entity_tab_index : 0,
        entities : [],
        curr_instances : [],
        show_assign_popup : false,
        instance : null,
        addedAnnotation : null,
        selected_text_quads : null,
        collapse : false,
        visibility : {},
        assign_anchor : null,
        show_annotation_popup : false,
        selected_annotation : null,
        selected_entity : null,
        selected_instance : null,
        annotation_anchor : null,
        show_clear_popup : false,
        clear_anchor : null,
        show_clearall_dialog : false,
        dialog_entity : null,
        dialog_instances : [],
        drl_result : null,
        curr_page : 1,
        total_pages : null,
        all_instances : [],
        instance_pages : [],
        assigned_entity : null,
        document_loading : true,
    }
    header = React.createRef()
    anchorEl = React.createRef()

    componentWillMount = () => {
        Action('http_request', {
            url : '/sainapse/pii/instance_pages_by_file',
            method : 'post',
            data : {
              ic_name : this.props.ic_name,
              file_name : this.props.file.path,
              version : this.props.version
            }
        }).then((res) => {
            console.log(res.data.result)
            res.data.result.Result.sort((a,b) => a - b)
            this.setState({...this.state, instance_pages : res.data.result.Result})
        }).catch(err => {

        })
        Action('http_request', {
            url : '/sainapse/pii/label_info',
            method : 'post',
            data : {
              ic_name : this.props.ic_name
            }
        }).then(res => {
        console.log(res.data)
        let entities = Object.fromEntries(
            Object.entries(res.data.result.Result).map(([key, val]) => ([
                key, { ...val, 'visibility' : false}
            ]))
        );
        console.log("entities", entities)
        this.setState({...this.state, entities : entities, entity_types : Object.keys(res.data.result.Result)}, () => {
            Action("http_request", {
                url: this.props.drl_url + "/drl/file",
                method: "get",
                params: {
                    wv_server: this.props.wv_server,
                    file_type: this.props.file.type,
                    file_id: this.props.file.id,
                }
                }).then((res) => {
                    console.log("drl_result ::", res.data)
                    this.setState({...this.state, drl_result : res.data, document_loading : true})
                }).catch(err => {

                })
            })
        }).catch(err => {
            
        })
    }

    componentDidUpdate = (prevState) => {
        
    }

    toggleVisibility = (instance, annotation, entityToggle) => {
        const { documentViewer, annotationManager, Annotations, Tools, PDFNet } = this.state.instance.Core;
        if(!this.state.visibility[instance.instance_id] || entityToggle === "hide") {
            annotation.StrokeColor.A = 1
            annotation.FillColor.A = 1
            annotation.Color.A = 1
            annotationManager.updateAnnotation(annotation)
            console.log("annotation found :: ", annotation)
            const annot = new Annotations.FreeTextAnnotation(Annotations.FreeTextAnnotation.Intent.FreeText, {
                PageNumber: annotation.PageNumber,
                X: annotation.X,
                Y: annotation.Y,
                Width: annotation.Width,
                Height: annotation.Height,
                TextAlign: 'left',
                TextVerticalAlign: 'center',
                TextColor: new Annotations.Color(0, 0, 0, 1),
                StrokeColor: annotation.StrokeColor,
                NoRotate : true,
                NoResize : true,
                NoMove : true,
                ReadOnly : true,
                });
                annot.setContents(`XXXXX`);
                annotationManager.addAnnotation(annot);
                annotationManager.drawAnnotations(annot.PageNumber).then(() => {
                    annotationManager.deselectAllAnnotations()
                    if(instance) {
                        let visibility = this.state.visibility
                        visibility[instance.instance_id] = true
                        this.setState({...this.state, visibility : visibility, show_annotation_popup : false, selected_annotation : null, selected_instance : null})
                    }
                });
        } else if (this.state.visibility[instance.instance_id] || entityToggle === "show") {
            annotationManager.deleteAnnotation(annotation, {force : true})
            let annotations = annotationManager.getAnnotationsList()
            console.log("new all annotations :: ", annotations)
            let new_annotations = annotations.filter((a) => (a.X === annotation.X && (a.Y) === (annotation.Y) && a.Width === annotation.Width && a.Height === annotation.Height))
            console.log(new_annotations)
            annotationManager.deleteAnnotations(new_annotations,{ force : true})
            let color = this.state.entities[instance.redact_label].color;
            const highlight = new Annotations.RectangleAnnotation();
                highlight.PageNumber = instance.page_num;
                highlight.StrokeColor = new Annotations.Color(color[0], color[1], color[2], 0.5);
                highlight.FillColor = new Annotations.Color(color[0], color[1], color[2], 0.5);
                highlight.X = instance.bbox_from.x
                highlight.Y = 792 - instance.bbox_to.y
                highlight.Width = instance.bbox_to.x - instance.bbox_from.x
                highlight.Height = instance.bbox_to.y - instance.bbox_from.y
                highlight.NoRotate = true
                highlight.NoResize = true
                highlight.Author = 'Sainapse'
                annotationManager.addAnnotation(highlight);
                annotationManager.drawAnnotations(highlight.PageNumber).then(()=>{
                    annotationManager.deselectAllAnnotations()
                    if(instance) {
                        let visibility = this.state.visibility
                        visibility[instance.instance_id] = false
                        this.setState({...this.state, visibility : visibility,show_annotation_popup : false, selected_annotation : null, selected_instance : null})
                    }
                });
        }
    }

    PageVisibility = (instance,entityToggle) => {
        const { documentViewer, annotationManager, Annotations, Tools, PDFNet } = this.state.instance.Core;
        let annotations = annotationManager.getAnnotationsList()
        console.log(annotations)
        let annot = annotations.find((a) => ((a instanceof Annotations.RectangleAnnotation && a.X === instance.bbox_from.x && a.Y === (792-instance.bbox_to.y) && a.Width === (instance.bbox_to.x - instance.bbox_from.x) && a.Height === (instance.bbox_to.y - instance.bbox_from.y))))
        if(annot) this.toggleVisibility(instance,annot,entityToggle)
    }

    popupVisibility = (instance) => {
        const { documentViewer, annotationManager, Annotations, Tools, PDFNet } = this.state.instance.Core;
        let annotations = annotationManager.getAnnotationsList()
        const annotation = annotations.find((a) => a === this.state.selected_annotation)
        console.log("visibility :: ", annotation)
        console.log("visibility :: ", this.state.visibility)
        if(annotation) {
            this.toggleVisibility(instance, this.state.selected_annotation, null)
        }
    }

    getClearConfirmationAnchor = (instance) => {
        const { documentViewer, annotationManager, Annotations, Tools, PDFNet } = this.state.instance.Core;
        this.setState({...this.state, show_annotation_popup: false, show_assign_popup: false}, () => {
            annotationManager.deselectAllAnnotations()
            let annotations = annotationManager.getAnnotationsList()
            console.log(annotations)
            let annot = annotations.find((a) => ((a instanceof Annotations.RectangleAnnotation && a.X === instance.bbox_from.x && a.Y === (792-instance.bbox_to.y) && a.Width === (instance.bbox_to.x - instance.bbox_from.x) && a.Height === (instance.bbox_to.y - instance.bbox_from.y))))
            if(annot) {
                const zoom = documentViewer.getZoomLevel()
                const displayMode = documentViewer.getDisplayModeManager().getDisplayMode();
                const pageNumber = annot.PageNumber;
                const pagePoint = {
                    x: Number(annot.X + annot.Width)/zoom,
                    y: Number(annot.Y)/zoom + 100
                };
                let anchorEl = { top : '', left : ''}
                anchorEl.top = displayMode.pageToWindow(pagePoint,pageNumber).y
                anchorEl.left = displayMode.pageToWindow(pagePoint,pageNumber).x
                let new_anchorEl = this.createAnchorElement(anchorEl)
                this.setState({...this.state, clear_anchor : new_anchorEl, show_clear_popup : true, selected_instance : instance, show_annotation_popup: false, show_assign_popup: false})
            }
        })
    }

    getInstances = () => {
        let curr_page = this.state.curr_page
        Actions('http_requests', [
            {
                url : '/sainapse/pii/instances_from_pages',
                method : 'post',
                data : {
                    ic_name : this.props.ic_name,
                    entity_types : this.state.entity_types,
                    file_name : this.props.file.path,
                    page_range : [1,this.state.total_pages],
                    probability_threshold : 0,
                    version : this.props.version
                }
            },
            {
                url : '/sainapse/pii/instance_pages_by_file',
                method : 'post',
                data : {
                  ic_name : this.props.ic_name,
                  file_name : this.props.file.path,
                  version : this.props.version
                }
            }
        ]).then((res) => {
            res[1].data.result.Result.sort((a,b) => a - b)
            this.setState({...this.state, all_instances : res[0].data.result.Result, instance_pages : res[1].data.result.Result})
        }).catch(err => {

        })
        Action('http_request', {
            url : '/sainapse/pii/instances_from_pages',
            method : 'post',
            data : {
              ic_name : this.props.ic_name,
              entity_types : this.state.entity_types,
              file_name : this.props.file.path,
              page_range : [curr_page,curr_page],
              probability_threshold : 0,
              version : this.props.version
            }
        }).then((res) => {
            this.setState({...this.state, curr_instances : res.data.result.Result}, () => {
                let annotations = this.state.instance.Core.annotationManager.getAnnotationsList()
                this.state.instance.Core.annotationManager.deleteAnnotations(annotations, {force : true})
                this.state.curr_instances.map((instance) => {   
                    let color = this.state.entities[instance.redact_label].color;
                    const highlight = new this.state.instance.Core.Annotations.RectangleAnnotation();
                    highlight.PageNumber = instance.page_num;
                    highlight.StrokeColor = new this.state.instance.Core.Annotations.Color(color[0], color[1], color[2], 0.5)
                    highlight.FillColor = new this.state.instance.Core.Annotations.Color(color[0], color[1], color[2], 0.5)
                    highlight.X = instance.bbox_from.x
                    highlight.Y = 792 - instance.bbox_to.y
                    highlight.Width = instance.bbox_to.x - instance.bbox_from.x
                    highlight.Height = instance.bbox_to.y - instance.bbox_from.y
                    highlight.NoRotate = true
                    highlight.NoResize = true
                    highlight.Author = 'Sainapse'
                    this.state.instance.Core.annotationManager.addAnnotation(highlight);
                    this.state.instance.Core.annotationManager.drawAnnotations(highlight.PageNumber).then(()=>{
                        this.state.instance.Core.annotationManager.deselectAllAnnotations()
                        console.log("done");
                    });
                    if(this.state.visibility[instance.instance_id]) {
                        highlight.StrokeColor.A = 1
                        highlight.FillColor.A = 1
                        highlight.Color.A = 1
                        this.state.instance.Core.annotationManager.updateAnnotation(highlight)
                        const annot = new this.state.instance.Core.Annotations.FreeTextAnnotation(this.state.instance.Core.Annotations.FreeTextAnnotation.Intent.FreeText, {
                        PageNumber: highlight.PageNumber,
                        X: highlight.X,
                        Y: highlight.Y,
                        Width: highlight.Width,
                        Height: highlight.Height,
                        TextAlign: 'left',
                        TextVerticalAlign: 'center',
                        TextColor: new this.state.instance.Core.Annotations.Color(0, 0, 0, 1),
                        StrokeColor: highlight.StrokeColor,
                        NoRotate : true,
                        NoResize : true,
                        NoMove : true,
                        ReadOnly : true,
                        });
                        annot.setContents(`XXXXX`);
                        this.state.instance.Core.annotationManager.addAnnotation(annot);
                        this.state.instance.Core.annotationManager.drawAnnotations(annot.PageNumber).then(() => {
                            this.state.instance.Core.annotationManager.deselectAllAnnotations()
                        });
                    }
                })
            })
        }).catch(err => {

        })    
    }

    dropInstance = (instance_ids) => {
        Action('http_request', {
            url : '/sainapse/pii/drop_instances',
            method : 'post',
            data : {
                ic_name : this.props.ic_name,
                file_name : this.props.file.path,
                page_num : this.state.curr_page,
                version : this.props.version,
                instance_ids : instance_ids
            }
        }).then((res) => {
            console.log(res.data.result.Result)
            this.setState({...this.state, show_annotation_popup : false, selected_annotation : null, selected_instance : null, show_clear_popup : false}, () => this.getInstances())
        }).catch(err => {

        })
    }

    addInstance = (assigned_entity) => {
        let bbox_from, bbox_to
        if(this.state.addedAnnotation) {
            bbox_from = { x : this.state.addedAnnotation.X, y : 792 - (this.state.addedAnnotation.Y + this.state.addedAnnotation.Height)}
            bbox_to = { x : this.state.addedAnnotation.X + this.state.addedAnnotation.Width, y : 792 - (this.state.addedAnnotation.Y)}
        } else {
            let quads = this.state.selected_text_quads
            let len = this.state.selected_text_quads.length
            let leftMostX = quads[len-1].x1
            let rightMostX = quads[0].x3
            quads.forEach((quad) => {
                if(quad.x1 < leftMostX) {
                    leftMostX = quad.x1
                }
                if(quad.x3 > rightMostX) {
                    rightMostX = quad.x3
                }
            })
            bbox_from = { x : leftMostX, y : (792 - this.state.selected_text_quads[len-1].y1)}
            bbox_to = { x : rightMostX, y : (792 - this.state.selected_text_quads[0].y3)}
        }
        Action('http_request', {
            url : '/sainapse/pii/add_instances',
            method : 'post',
            data : {
              ic_name : this.props.ic_name,
              file_name : this.props.file.path,
              page_num : this.state.curr_page,
              version : this.props.version,
              new_instances : [
                {
                    bbox_from : bbox_from,
                    bbox_to : bbox_to,
                    file_name : this.props.file.path,
                    redact_label : assigned_entity,
                    redact_class : "TP",
                    page_num : this.state.curr_page,
                    instance_id : 1,
                    score : 0.8
                }
              ],
            }
        }).then((res) => {
            this.setState({...this.state, show_assign_popup : false, assigned_entity : null, addedAnnotation : null, selected_text_quads : null},() => this.getInstances())
        }).catch(err => {

        })
    }
    
    getAnchorEl = (annotation) => {
        const { documentViewer } = this.state.instance.Core
        const zoom = documentViewer.getZoomLevel()
        const displayMode = documentViewer.getDisplayModeManager().getDisplayMode();
        const pageNumber = annotation.PageNumber;
        const pagePoint = {
            x: Number(annotation.X + annotation.Width)/zoom,
            y: Number(annotation.Y)/zoom + 100
        };
        let anchorEl = { top : '', left : ''}
        anchorEl.top = displayMode.pageToWindow(pagePoint,pageNumber).y
        anchorEl.left = displayMode.pageToWindow(pagePoint,pageNumber).x
        return anchorEl;
    }

    createAnchorElement = (coordinates) => {
        if(this.state.annotation_anchor !== null || this.state.clear_anchor !== null){
            let anchor = document.getElementById('anchor-element')
            anchor.remove()
        }
        let top_coord = coordinates.top + 'px', left_coord = coordinates.left + 'px'
        if (!coordinates) return;
        // const x = coordinates.left
        // const y = coordinates.top
        const div = document.createElement('div');
        div.style.position = 'absolute';
        div.style.left = left_coord;
        div.style.top = top_coord;
        div.ref = this.anchorEl;
        div.id = 'anchor-element'
        console.log(div)
        document.body.appendChild(div);
        return div
    }

    initializeWebViewer = (instance) => {
        const { documentViewer, annotationManager, Annotations, Tools} = instance.Core;
        this.setState({...this.state,instance : instance})
        instance.UI.disableElements(['toolsOverlay','toolsHeader','richTextPopup','toolStylePopup','textPopup','annotationPopup','contextMenuPopup','menuButton','leftPanelButton','viewControlsButton','toggleNotesButton','ribbons','annotationCommentButton','linkButton','annotationStyleEditButton', 'annotationDeleteButton'])
        instance.UI.disableFadePageNavigationComponent()
        instance.UI.setHeaderItems(header => {
            const items = header.getItems()
            console.log(items)
            items.splice(10,0,{
                type: 'toolButton',
                toolName: 'AnnotationCreateRectangle',
                title : 'Highlight'
            }
            )
            header.update(items)
        })
        annotationManager.addEventListener('annotationChanged',(annotations,action) => {
            annotations.forEach(annotation => {
                if (action === 'add') {
                  annotation.disableRotationControl();
                }
            });
            if(action === 'add' && annotations[0].Author !== 'Sainapse' && annotations[0] instanceof Annotations.RectangleAnnotation) {
                this.setState({...this.state, show_assign_popup : false, addedAnnotation : annotations[0]})
                console.log("Annotation added ::", annotations)
                let anchorEl = this.getAnchorEl(annotations[0])
                //let new_anchorEl = this.createAnchorElement(anchorEl)
                this.setState({...this.state,assign_anchor : anchorEl, show_assign_popup: true, show_annotation_popup: false, show_clear_popup: false});
                //this.setState({...this.state, show_assign_popup : true})
            }
        })
        const displayModeManager = documentViewer.getDisplayModeManager();
        displayModeManager.setDisplayMode(new instance.Core.DisplayMode(documentViewer, instance.Core.DisplayModes.Single));
        annotationManager.addEventListener('annotationSelected',(annotations,action) => {
            if( action === 'deselected') {
                this.setState({...this.state, show_annotation_popup : false, selected_annotation : null, selected_instance : null})
            }
            if( action === 'selected') {
                console.log("annotaion selected :: ", annotations)
                // if(this.state.annotation_anchor !== null || this.state.clear_anchor !== null){
                //     let anchor = document.getElementById('anchor-element')
                //     anchor.remove()
                // }
                let anchorEl = this.getAnchorEl(annotations[0])
                let new_anchorEl = this.createAnchorElement(anchorEl)
                this.setState({...this.state,annotation_anchor : new_anchorEl, show_annotation_popup : true, selected_annotation : annotations[0], show_assign_popup: false, show_clear_popup: false}, () => {
                    let bbox_from = { x : this.state.selected_annotation.X, y : 792 - (this.state.selected_annotation.Y + this.state.selected_annotation.Height)}
                    let bbox_to = { x : this.state.selected_annotation.X + this.state.selected_annotation.Width, y : 792 - (this.state.selected_annotation.Y)}
                    console.log(bbox_from,bbox_to)
                    let selected_instance = this.state.curr_instances.find((instance) => (instance.bbox_from.x === bbox_from.x && instance.bbox_from.y === bbox_from.y && instance.bbox_to.x === bbox_to.x && instance.bbox_to.y === bbox_to.y))
                    console.log("selected_instance ::", selected_instance)
                    this.setState({...this.state, selected_instance : selected_instance})
                })
            }
        })
        const tool1 = documentViewer.getTool(Tools.ToolNames.RECTANGLE);
        documentViewer.addEventListener('documentLoaded', async () => {
            documentViewer.setToolMode(tool1);
            this.setState({...this.state, total_pages : documentViewer.getPageCount()}, () => {
                Action('http_request', {
                    url : '/sainapse/pii/instances_from_pages',
                    method : 'post',
                    data : {
                    ic_name : this.props.ic_name,
                    entity_types : this.state.entity_types,
                    file_name : this.props.file.path,
                    page_range : [1,this.state.total_pages],
                    probability_threshold : 0,
                    version : this.props.version
                    }
                }).then((res) => {
                    this.setState({...this.state, all_instances : res.data.result.Result, document_loading : false})
                }).catch(err => {

                })
            })
            documentViewer.addEventListener('pageNumberUpdated',(pageNum, canvas) => {
                this.setState({...this.state, curr_page : pageNum}, () => this.getInstances())
            })
        });
        const tool = documentViewer.getTool(Tools.ToolNames.TEXT_SELECT);
        tool.addEventListener('selectionComplete', (startQuad, allQuads) => {
            const zoom = documentViewer.getZoomLevel()
            const displayMode = documentViewer.getDisplayModeManager().getDisplayMode();
            const pageNumber = startQuad.pageNumber;
            const pagePoint = {
                x: Number(startQuad.quad.x3)/zoom + 10,
                y: Number(startQuad.quad.y3)/zoom + 90
            };
            let anchorEl = { top : '', left : ''}
            anchorEl.top = displayMode.pageToWindow(pagePoint,pageNumber).y
            anchorEl.left = displayMode.pageToWindow(pagePoint,pageNumber).x
            this.setState({...this.state,assign_anchor : anchorEl});
            this.setState({...this.state, show_assign_popup : true, selected_text_quads : allQuads[this.state.curr_page]})
        });
        let curr_page = documentViewer.getCurrentPage()
        Action('http_request', {
            url : '/sainapse/pii/instances_from_pages',
            method : 'post',
            data : {
              ic_name : this.props.ic_name,
              entity_types : this.state.entity_types,
              file_name : this.props.file.path,
              page_range : [curr_page, curr_page],
              probability_threshold : 0,
              version : this.props.version
            }
        }).then((res) => {
            let visibility = {}
            res.data.result.Result.map((instance) => {
                visibility[instance.instance_id] = false
            })
            console.log("visibility check ::", visibility)
            this.setState({...this.state, curr_instances : res.data.result.Result, visibility : visibility}, () => {
                this.state.curr_instances.map((instance) => {
                    let color = this.state.entities[instance.redact_label].color;
                    const highlight = new Annotations.RectangleAnnotation();
                    highlight.PageNumber = instance.page_num;
                    highlight.StrokeColor = new Annotations.Color(color[0], color[1], color[2], 0.5)
                    highlight.FillColor = new Annotations.Color(color[0], color[1], color[2], 0.5)
                    highlight.X = instance.bbox_from.x
                    highlight.Y = 792 - instance.bbox_to.y
                    highlight.Width = instance.bbox_to.x - instance.bbox_from.x
                    highlight.Height = instance.bbox_to.y - instance.bbox_from.y
                    highlight.NoRotate = true
                    highlight.NoResize = true
                    highlight.Author = 'Sainapse'
                    annotationManager.addAnnotation(highlight);
                    annotationManager.drawAnnotations(highlight.PageNumber)
                })
            })
        }).catch(err => {

        })    
    }

    renderSummary = () => {
        if(!this.state.document_loading) {
            return(
                <div style = {{width : '100%', height : 'calc(100vh - 200px)'}}>
                    <TableContainer style = {{ width : '100%', maxHeight: '100%'}}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ width : '20%'}}></TableCell>
                                    <TableCell> Entities</TableCell>
                                    <TableCell>Count</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    this.state.entity_types.map((entity) => {
                                        let filtered_instances = this.state.all_instances.filter((i)=> i.redact_label === entity)
                                        console.log(filtered_instances)
                                        return(
                                            <TableRow>
                                                <TableCell style={{ width : '20%'}}><div style = {{ width : '20px', height : '20px', backgroundColor : "rgb("+this.state.entities[entity].color[0]+","+this.state.entities[entity].color[1]+","+this.state.entities[entity].color[2]+")" }}></div></TableCell>
                                                <TableCell>{entity}</TableCell>
                                                <TableCell>{filtered_instances.length}</TableCell>
                                            </TableRow>
                                        );
                                    })
                                }
                                <TableRow>
                                    <TableCell colSpan={2}><Typography variant = 'body1' style={{}}>Total instances count :</Typography></TableCell>
                                    <TableCell><Typography variant = 'body1'>{this.state.all_instances.length}</Typography></TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {/* <div style={{ display: 'flex', flexDirection: 'row', marginTop : '10px', padding : '10px' }}>
                        <Typography variant = 'body1' style={{}}>Total instances count :</Typography>
                        <Typography variant = 'body1' style={{marginLeft: 'auto', marginRight: '5px'}}>{this.state.all_instances.length}</Typography>
                    </div> */}
                </div>  
            );
        } else {
            console.log("summary loading", this.state.document_loading)
            return(
                <Fragment>
                    {this.state.document_loading && <div style = {{width : '100%', height : 'calc(100vh - 200px)', display : 'flex', flexDirection : 'column', justifyContent : 'center', alignItems : 'center'}}>
                        <CircularProgress variant = 'indeterminate' color = 'primary'/>
                    </div>}
                </Fragment>    
            );
        }   
    }

    renderPage = () => {
        return(
            <div style={{ width : '100%', height : 'calc(100vh - 200px)', display : 'flex', flexDirection : 'column'}}>
                <div style={{width : '100%', display : 'flex', flexDirection : 'row', borderBottom : '1px solid rgba(0,0,0,0.12)', padding :'5px'}}>
                    <Typography variant='overline' style={{ width : '20%'}}>Page No:</Typography>
                    <Typography variant='overline' style={{ width : '80%'}}>Entities</Typography>
                </div>
                <div style={{ width : '100%', height:'calc(100% - 50px)', display: 'flex', flexDirection: 'row'}}>
                    <div style={{ width : '20%', height : '100%', borderRight : '1px solid rgba(0,0,0,0.12)', overflow : 'auto', padding : '10px', display : 'flex', flexDirection : 'column'}}>
                        {this.state.instance_pages.length > 0 && this.state.instance_pages.map((page) => {
                            return(
                                <div style={{ width : '100%', display: 'flex', flexDirection: 'row', justifyContent : 'center', alignItems : 'center', height : '100px', border: page === this.state.curr_page?'1px solid rgba(24,144,255,1)' : '1px solid rgba(0,0,0,0.54)', marginTop : '10px'}} onClick={() => {
                                    this.state.instance.Core.documentViewer.setCurrentPage(page)
                                }}>
                                    <Typography gutterBottom variant='h5' align='center' style={{ padding : '5px', margin : 'auto', cursor : 'pointer', color : page === this.state.curr_page?'#1890ff' : 'rgba(0,0,0,0.54)'}}>{page}</Typography>
                                </div>
                            );
                        })}
                    </div>
                    <div style={{ width : '80%', height : '100%'}}>
                        {this.state.entity_types.map((entity) => {
                            let filtered_instances = this.state.curr_instances.filter((instance) => instance.redact_label === entity)
                            return(
                                <Accordion elevation={0} variant='elevation' style = {{ width : '100%', padding : '5px'}}>
                                    <AccordionSummary 
                                        style = {{width : '100%'}} 
                                        expandIcon = {<ExpandMore fontSize = 'small'/>}
                                    >
                                        <div style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                                            <div square 
                                            style = {{
                                                width : '20px', 
                                                height : '20px', 
                                                marginRight: '10px', 
                                                backgroundColor : "rgb("+this.state.entities[entity].color[0]+","+this.state.entities[entity].color[1]+","+this.state.entities[entity].color[2]+")" }}>
                                            </div>
                                            <Typography variant='subtitle2'>{entity} ({filtered_instances.length})</Typography>
                                            <IconButton 
                                                style={{ marginRight: '5px', marginLeft: 'auto'}} color = 'secondary' size = 'small' 
                                                onClick = {() => { 
                                                    this.setState({...this.state, show_clearall_dialog : true, dialog_entity : entity, dialog_instances : filtered_instances})
                                                }}>
                                                <Clear fontSize = 'small'/>
                                            </IconButton>
                                            <IconButton 
                                                style={{ color: '#40B5AD', marginRight: '5px'}} 
                                                size = 'small' 
                                                onClick = {async () => {
                                                    await filtered_instances.map((instance) => {
                                                        this.PageVisibility(instance,this.state.entities[entity].visibility ? "show" : "hide") 
                                                    })
                                                    let entities = this.state.entities
                                                    entities[entity].visibility = !entities[entity].visibility
                                                    this.setState({...this.state, entities : entities})
                                                }}>
                                                {this.state.entities[entity].visibility?<Visibility fontSize = 'small'/>:<VisibilityOff fontSize = 'small'/>}
                                            </IconButton>
                                        </div>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div style={{ width : '100%', display: 'flex', flexDirection : 'column'}}>
                                            {filtered_instances.length === 0 && <Typography variant='body2'>No instances found</Typography>}
                                            {filtered_instances.map((instance) => {
                                                return(
                                                    <div style={{ width : '100%', display: 'flex', flexDirection : 'row', borderBottom : '1px solid rgba(0,0,0,0.12)', marginBottom:'5px', padding : '5px'}}>
                                                        <div style={{ flexGrow : 1, cursor : 'pointer'}} onClick = {() => {
                                                            const { annotationManager, Annotations } = this.state.instance.Core;
                                                            let annotations = annotationManager.getAnnotationsList()
                                                            console.log(annotations)
                                                            let annot = annotations.find((a) => ((a instanceof Annotations.RectangleAnnotation && a.X === instance.bbox_from.x && a.Y === (792-instance.bbox_to.y) && a.Width === (instance.bbox_to.x - instance.bbox_from.x) && a.Height === (instance.bbox_to.y - instance.bbox_from.y))))
                                                            if(annot) {
                                                                annotationManager.deselectAllAnnotations()
                                                                annotationManager.selectAnnotation(annot)  
                                                            }
                                                        }}>
                                                            <Typography variant='body2'>Instance ID : {instance.instance_id}</Typography>
                                                        </div>
                                                        <div style={{ display: 'flex', flexDirection:'row'}}>
                                                            <IconButton 
                                                            style={{ marginRight: '5px', marginLeft: 'auto'}} color = 'secondary' size = 'small' 
                                                            onClick = {() => { 
                                                                this.getClearConfirmationAnchor(instance)
                                                            }}>
                                                            <Clear fontSize = 'small'/>
                                                            </IconButton>
                                                            <IconButton style={{ color: '#40B5AD', marginRight: '5px'}} size = 'small' onClick = {() => this.PageVisibility(instance)}>
                                                                {this.state.visibility[instance.instance_id]?<Visibility fontSize = 'small'/>:<VisibilityOff fontSize = 'small'/>}
                                                            </IconButton>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </AccordionDetails>
                                </Accordion>    
                            );
                        })}
                    </div>
                </div> 
            </div>
        );
    }

    renderTabContent = () => {
        return (
            <div style = {{width : '100%', height : '100%', overflow : 'auto'}}>
                {this.state.entity_tab_index === 0 && this.renderSummary()}
                {this.state.entity_tab_index === 1 && this.renderPage()}
            </div>
        );
    }

    renderSidePanel = () => {
        return(
            <div style = {{width : '100%', height : '100%', borderLeft : '1px solid rgba(0,0,0,0.12)'}}>
                <Paper square elevation = {0} style = {{width : '100%', height : '50px', display : 'flex', flexDirection : 'row', alignItems : 'center', padding : '10px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                    <Typography variant = 'subtitle2'>Entities</Typography>
                </Paper>
                <Paper
                    square
                    variant = 'outlined'
                    style = {{width : '100%', height : '50px'}}
                >
                    <AntTabs
                        value={this.state.entity_tab_index}
                        variant = 'fullWidth'
                        scrollButtons="auto"
                        indicatorColor="primary"
                        textColor="primary"
                        onChange = {(event, newValue) =>
                            this.setState((prevState)=>({...prevState, entity_tab_index : newValue}))
                        }
                    >
                        <AntTab label = "Summary"/>
                        <AntTab label = "Page"/>
                    </AntTabs>
                </Paper>
                {this.renderTabContent()}
            </div>
        );
    }

    renderClearAllInstancesDialog = () => {
        return(
            <Dialog open={this.state.show_clearall_dialog} onClose = {() => this.setState({...this.state, show_clearall_dialog : false})}>
                <div style={{ display : 'flex', flexDirection : 'column', padding : '10px'}}>
                    <Typography variant='subtitle2' style={{ padding: '5px'}}>Are you sure you want to reject all instances of {this.state.dialog_entity} from current page?</Typography>
                    <div style={{ display : 'flex', flexDirection : 'row-reverse', padding : '5px'}}>
                            <Button 
                                variant='outlined' 
                                color='primary' 
                                size='small'
                                onClick={() => {

                                    this.setState({...this.state,show_clearall_dialog : false})
                                }}
                            >Cancel</Button>
                            <Button 
                                variant='outlined' 
                                color='secondary' 
                                size='small'
                                style={{ marginRight : '5px'}} startIcon={<Clear/>} 
                                onClick={ () => {
                                    this.setState({...this.state, show_clearall_dialog : false})
                                    this.dropInstance(this.state.dialog_instances.map((i) => i.instance_id))
                                }}
                            >Reject</Button>
                        </div>
                </div>
            </Dialog>
        );
    }

    renderClearPopup = () => {
        return(
            <Popper
            style = {{zIndex : "8"}}
            placement = 'right-start'
            anchorEl = {this.state.clear_anchor}
            open = {this.state.show_clear_popup}
            // anchorReference="anchorPosition"
            // anchorPosition={{top: this.state.clear_anchor.top, left: this.state.clear_anchor.left}}
            onClose={()=> {
                //document.body.removeChild(this.state.clear_anchor)
                this.setState({...this.state, clear_anchor : null, show_clear_popup : false, selected_instance : null},() => this.state.instance.Core.annotationManager.deselectAllAnnotations())
            }}
            // anchorOrigin={{
            // vertical: 'top',
            // horizontal: 'left',
            // }}
            // transformOrigin={{
            // vertical: 'top',
            // horizontal: 'left',
            // }}
            >
                <Paper elevation={6}>
                    <div style={{ display : 'flex', flexDirection : 'row'}}>
                        <div style={{marginTop : '5px', marginBottom : '5px'}}>
                            <ArrowLeft style={{color: '#00D100'}} fontSize='large' variant='filled'/>
                        </div>
                        <div style={{ width : '200px', padding : '5px'}}>
                            <div style={{ display: 'flex', flexDirection: 'column'}}>
                                <Typography variant = 'body2' style={{paddingLeft : '5px'}}>Instance ID : {this.state.selected_instance.instance_id}</Typography>
                                <Typography variant = 'caption' style={{paddingLeft : '5px', color: 'rgb(0,0,0,0.54)'}}>{this.state.selected_instance.redact_label}</Typography>
                            </div>
                            <div style={{ display : 'flex', flexDirection : 'row', padding : '5px'}}>
                                <Button 
                                    variant='outlined' 
                                    color='secondary' 
                                    size='small'
                                    style={{ marginRight : '5px'}} startIcon={<Clear/>} 
                                    onClick={ () => {
                                        let instance_ids = []
                                        instance_ids.push(this.state.selected_instance.instance_id)
                                        this.dropInstance(instance_ids)
                                        //document.body.removeChild(this.state.clear_anchor)
                                    }}
                                >Reject</Button>
                                <Button 
                                    variant='outlined' 
                                    color='primary' 
                                    size='small'
                                    onClick={() => {
                                        this.setState({...this.state,clear_anchor : null, show_clear_popup : false, selected_instance : null}, () => this.state.instance.Core.annotationManager.deselectAllAnnotations())
                                    }}
                                >Cancel</Button>
                            </div>
                        </div>
                    </div>
                </Paper>
            </Popper>
        );
    }

    renderAnnotationPopup = () => {
        console.log(this.state.annotation_anchor)
        return(
                <Popper
                style = {{zIndex : "8"}}
                placement = 'right-start'
                anchorEl = {this.state.annotation_anchor}
                open = {this.state.show_annotation_popup}
                //anchorReference="anchorPosition"
                //anchorPosition={{top: this.state.annotation_anchor.top, left: this.state.annotation_anchor.left}}
                onClose={()=> {
                    this.setState({...this.state, annotation_anchor : null, show_annotation_popup : false, selected_annotation : null},() => this.state.instance.Core.annotationManager.deselectAllAnnotations())
                }}
                // anchorOrigin={{
                // vertical: 'top',
                // horizontal: 'left',
                // }}
                // transformOrigin={{
                // vertical: 'top',
                // horizontal: 'left',
                // }}
                >
                    <Paper elevation={6}>
                        <div style={{ display : 'flex', flexDirection : 'row'}}>
                            <div style={{marginTop : '5px', marginBottom : '5px'}}>
                                <ArrowLeft style={{ color: '#00D100' }} fontSize='large' variant='filled'/>
                            </div>
                            <div style={{ width : '200px', padding : '5px'}}>
                                <div style={{ display : 'flex', flexDirection : 'row', }}>
                                    <div style={{padding: '5px', marginTop: '10px', width : '30px', height : '30px', backgroundColor : "rgb("+this.state.selected_annotation.Color.R+","+this.state.selected_annotation.Color.G+","+this.state.selected_annotation.Color.B+")"}}></div>
                                    <div style={{ display: 'flex', flexDirection: 'column', padding: '5px'}}>
                                        <Typography variant = 'body2' style={{paddingLeft : '5px'}}>Instance ID : {this.state.selected_instance.instance_id}</Typography>
                                        <Typography variant = 'caption' style={{paddingLeft : '5px', color: 'rgb(0,0,0,0.54)'}}>{this.state.selected_instance.redact_label}</Typography>
                                    </div>
                                    <div style={{marginLeft: 'auto', padding: '5px'}}>
                                        <IconButton size='small' onClick={()=> {
                                            //document.body.removeChild(this.state.annotation_anchor)
                                            this.setState({...this.state, annotation_anchor : null, show_annotation_popup : false, selected_annotation : null},() => this.state.instance.Core.annotationManager.deselectAllAnnotations())
                                            }}>
                                        <Clear fontSize='small'/></IconButton>
                                    </div>
                                </div>
                                <div style={{ display : 'flex', flexDirection : 'row', padding : '5px'}}>
                                    <Button 
                                        variant='outlined' 
                                        color='secondary' 
                                        size='small'
                                        style={{ marginRight : '5px'}} startIcon={<Clear/>} 
                                        onClick={ () => {
                                            let instance_ids = []
                                            instance_ids.push(this.state.selected_instance.instance_id)
                                            this.dropInstance(instance_ids)
                                            //document.body.removeChild(this.state.annotation_anchor)
                                        }}
                                    >Reject</Button>
                                    <Button 
                                        variant='outlined' 
                                        color='primary' 
                                        size='small'
                                        startIcon={this.state.visibility[this.state.selected_instance.instance_id]?<Visibility/> : <VisibilityOff/>} 
                                        onClick={() => {
                                            // this.setState({...this.state, show_annotation_popup : false})
                                            console.log("selected entity :: ", this.state.selected_instance)
                                            if(this.state.selected_instance !== -1) {
                                                this.popupVisibility(this.state.selected_instance)
                                            }
                                            //document.body.removeChild(this.state.annotation_anchor)
                                        }}
                                    >{this.state.visibility[this.state.selected_instance.instance_id]? 'View' : 'Redact'}</Button>
                                </div>
                            </div>
                        </div>
                    </Paper>
            </Popper>
        );
    }

    renderAssignPopup = () => {
        return(
            <Popover
                // style = {{zIndex : "8"}}
                // placement = 'right-start'
                //anchorEl = {this.state.assign_anchor}
                open={this.state.show_assign_popup}
                anchorReference="anchorPosition"
                anchorPosition={{ top: this.state.assign_anchor.top, left: this.state.assign_anchor.left}}
                onClose={()=> {
                    this.setState({...this.state, assign_anchor: null, show_assign_popup : false, assigned_entity : null},() => this.getInstances())
                }}
                anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
                }}
                transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
                }}
                >
                    <Paper elevation={6}>
                        <div style={{ display : 'flex', flexDirection : 'row'}}>
                            <div style={{marginTop : '5px', marginBottom : '5px'}}>
                                <ArrowLeft style={{ color: '#00D100' }} fontSize='large' variant='filled'/>
                            </div>
                            <FormControl style={{width:'300px', padding : '5px'}} variant = 'outlined' fullWidth size = 'small'>
                                <InputLabel>Select Entity Type</InputLabel>
                                <Select
                                value = {this.state.assigned_entity}
                                label = 'Entity'
                                onChange={(event) => {
                                    //document.body.removeChild(this.state.assign_anchor)
                                    this.setState({...this.state,assigned_entity : event.target.value}, () => this.addInstance(event.target.value))
                                }}
                            >
                                {Object.keys(this.state.entities).map((entity) => {
                                    return(
                                        <MenuItem value={entity}>{entity}</MenuItem>
                                    );
                                })}
                            </Select>
                            </FormControl>
                        </div>
                    </Paper>
            </Popover>
        );
    }

    renderViewer = (viewer_height) => {
        return(
            <PDFtronViewer
                initializeWebViewer = {(instance) => {this.initializeWebViewer(instance)}}
                src = {this.props.drl_url + "/" + this.state.drl_result.file_link}
                viewer_height = {viewer_height}
            />
        );
    }

    render () {
        var toPX = require("to-px");
        let cur_height = toPX('100vh')
        let viewer_height = cur_height - 100
        return (
            <ThemeProvider theme = {blue_theme}>
                <div 
                    ref = {this.header} 
                    style = {{
                        width : '100%', 
                        height : 'calc(100vh - 50px)',
                    }}
                >   
                    <Paper variant = 'outlined' square style = {{width : '100%', height : '50px', padding : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                        <Typography style = {{fontSize : 20, fontWeight : 600, flexGrow: 1}} variant = 'h6'>PII Detection</Typography>
                        <Button
                            color = 'primary'
                            onClick = {this.props.close_review}
                            style = {{ display : 'flex', alignItems : 'flex-end'}}
                        >
                            Close
                        </Button>
                    </Paper>
                    <div style = {{width : '100%', height : 'calc(100%-50px)', display : 'flex', flexDirection : 'row'}}>
                        <div style = {{width : '75%', height : '100%'}}>
                            {this.state.drl_result && this.renderViewer(viewer_height)}
                            {this.state.show_clearall_dialog && this.renderClearAllInstancesDialog()}
                            {this.state.show_clear_popup && this.state.selected_instance && this.state.clear_anchor && this.renderClearPopup()}
                            {this.state.show_annotation_popup && this.state.selected_annotation && this.state.selected_instance && this.renderAnnotationPopup()}
                            {this.state.show_assign_popup && this.renderAssignPopup()}
                        </div>
                        <div style = {{width : '25%', height : '100%'}}>
                            {this.renderSidePanel()}
                        </div>
                    </div>
                </div>
            </ThemeProvider>
        );
    }
}

export default withStyles(styles)(Review);